import { cn, downloadURI } from 'utils/helpers';
import { useParams } from 'react-router-dom';
import { Button } from 'ui/components/common';
import useModal from 'ui/partials/Modal/useModal';
import { SIZE } from 'utils/constants';

import { useGetAttachments } from '../hooks';
import AttachedItemsList from './AttachedItemsList';
import ViewAllAttachmentsModal from './ViewAllAttachmentsModal';

const ContactAttachments = ({
  source,
}: {
  source: 'Lead' | 'Company' | 'Deal';
}) => {
  const params = useParams();
  const { data } = useGetAttachments({ referenceId: params.id, source });
  const attachments = data?.data;

  const { showModal } = useModal();

  const showAllAttachmentsModal = () => {
    showModal({
      content: (
        <ViewAllAttachmentsModal
          referenceId={params.id as string}
          source={source}
          onPreviewClose={showAllAttachmentsModal}
        />
      ),
      title: 'Attachments',
      size: SIZE.Large,
    });
  };

  return (
    <div className="pt-[18px]">
      <div
        className={cn(
          'text-xs py-[18px] pb-0',
          'border-t-[0.5px] border-separator-primary',
        )}
      >
        {!attachments?.length ? (
          'See the files attached to your activities or uploaded to this record.'
        ) : (
          <AttachedItemsList
            attachments={attachments}
            onDownload={downloadURI}
            onClickShowAllAttachments={showAllAttachmentsModal}
          />
        )}
      </div>
      {!!attachments?.length && (
        <Button
          intent={'link'}
          onClick={showAllAttachmentsModal}
          className="mx-auto leading-[22px] text-sm font-semibold tracking-[0.04em] pb-0"
          label="View all attachments"
        />
      )}
    </div>
  );
};

export default ContactAttachments;
